
import { useEffect, useState } from "react"
import url from "../api/url"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"
import { meses } from "../data/datos"

const useExperienciaSectorProductivo = () => {

    // variables
    const setToast = useEmpleadoStore( state => state.setToast )
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const expInicial = {
        funcion: 'guardarExp',
        tipo: 'sectorProductivo',
        inicio: '',
        final: '',
        puesto: '',
        empresa: '',
        correo: objLogueado.email
    }
    const { URL } = url()
    const [isOpen, setIsOpen] = useState( false )
    const [exp, setExp] = useState([])
    const [formExp, setformExp] = useState( expInicial )
    const [pkExp, setPkExp] = useState( 0 )
    const [cargando, setCargando] = useState( false )



    // funciones
    const traerExp = () => {

        var fd = new FormData()
        fd.append("funcion", "traerExp")
        fd.append("tipo", "sectorProductivo")
        fd.append("correo", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setExp( e )
        })
        .catch( a => {
            setToast( true )
        })

    }


    const guardarExp = () => {

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body: JSON.stringify({ ...formExp, pkExp })
        })
        .then( res => res.json() )
        .then( function (d) {
            traerExp()
            alert( d.mensaje )
            if ( d.codigo === 1 && pkExp === 0 ) {
                setformExp( expInicial )
            }
            // eslint-disable-next-line
            if (d.codigo == 1) {
                cerrarModal()
            }
        })
        .catch( a => {
            alert("Error al guardar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.")
        })
        .finally( () => setCargando( false ) )
    }

    const abrirModal = ( borrar_pk = true ) => {
        setIsOpen( true )
        if ( borrar_pk ) {
            setPkExp( 0 )
        }
    }

    const cerrarModal = () => {
        setIsOpen( false )
        setformExp( expInicial )
    }

    function borrarExp( pk_exp ) {
        if ( pk_exp && window.confirm("El registro será eliminado.") ) {
            fetch( URL, {
                method: 'post',
                body: JSON.stringify({ pk_exp: pk_exp, funcion: 'borrarExp' })
            })
            .then( res => res.json() )
            .then( function (d) {
                if ( d.codigo === 1 ) {
                    traerExp()
                    elToast( 'Eliminado con éxito' )
                } else {
                    elToast( d.mensaje, 'info' )
                }
            })
            .catch( a => {
                alert("Error al eliminar información.\nPuedes revisar tu conexión o iniciar sesión nuevamente.")
            })
        }
    }

    function llenarFormExp( e ) {
        setformExp({
            funcion: 'guardarExp',
            tipo: 'sectorProductivo',
            inicio: e.inicio,
            final: e.final,
            puesto: e.puesto,
            empresa: e.empresa,
            correo: objLogueado.email
        })
        setPkExp( e.pk_exp )
        abrirModal( false )
    }

    function formatearFecha(fecha) {
        let a = fecha.split('-')

        if (a[1]) {

            let b = meses[a[1] - 1]
            return `${b} del ${a[0]}`

        } else {
            return a[0]
        }
    }


    // useEffects
    useEffect(() => {
        traerExp()
        // eslint-disable-next-line
    }, [])


    return {
        isOpen, abrirModal, cerrarModal,
        guardarExp, setformExp, formExp,
        traerExp, exp,
        llenarFormExp, cargando, borrarExp,
        formatearFecha
    }
}

export default useExperienciaSectorProductivo
